export const handbookCopy = {
  handb_prev: "Anterior",
  handb_next: "Próximo",
}
